import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ed4116e0"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=ed4116e0&prod&lang=stylus"
import style1 from "./App.vue?vue&type=style&index=1&id=ed4116e0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports